import React from 'react';
import { motion } from 'framer-motion';
export function BookingIframe() {
  return <section id="booking" className="w-full py-20 px-4 bg-cream" data-id="element-7">
      <div className="max-w-5xl mx-auto" data-id="element-8">
        <div className="text-center mb-12" data-id="element-9">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gold mb-4" data-id="element-10">
            Agenda tu Experiencia VR
          </h2>
          <p className="text-lg text-charcoal/80" data-id="element-11">
            Selecciona el servicio y el horario que mejor te convenga.
            Confirmación inmediata.
          </p>
          <div className="flex items-center justify-center gap-4 mt-6" data-id="element-12">
            <div className="w-16 h-0.5 bg-gold" data-id="element-13" />
            <div className="w-2 h-2 bg-gold rotate-45" data-id="element-14" />
            <div className="w-16 h-0.5 bg-gold" data-id="element-15" />
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="w-full h-[700px] rounded-2xl overflow-hidden shadow-2xl shadow-pink/20 border border-gold/20 bg-white" data-id="element-16">
          <iframe src="https://vrbeautystudio.koob.uy/" className="w-full h-full border-0" title="Agenda de reservas VR Beauty Studio" data-id="element-17" />
        </motion.div>
      </div>
    </section>;
}